/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCaseNoteRequest
 */
export interface CreateCaseNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    fileNoteDetail: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    fileNoteDescription: string | null;
}

/**
 * Check if a given object implements the CreateCaseNoteRequest interface.
 */
export function instanceOfCreateCaseNoteRequest(value: object): value is CreateCaseNoteRequest {
    if (!('fileNoteDetail' in value) || value['fileNoteDetail'] === undefined) return false;
    if (!('fileNoteDescription' in value) || value['fileNoteDescription'] === undefined) return false;
    return true;
}

export function CreateCaseNoteRequestFromJSON(json: any): CreateCaseNoteRequest {
    return CreateCaseNoteRequestFromJSONTyped(json, false);
}

export function CreateCaseNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileNoteDetail': json['fileNoteDetail'],
        'fileNoteDescription': json['fileNoteDescription'],
    };
}

export function CreateCaseNoteRequestToJSON(value?: CreateCaseNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileNoteDetail': value['fileNoteDetail'],
        'fileNoteDescription': value['fileNoteDescription'],
    };
}

